import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PARAMETERS_INIT_LOADING, PARAMETERS_INIT_SUCCESS, PARAMETERS_INIT_FAIL, MODGENERAL_INIT_LOADING, MODGENERAL_INIT_SUCCESS, MODGENERAL_INIT_FAIL } from '@/store/types'
// import { checkAccess } from '@/router/accessRouteGuard'
export const general = {
  async parametersInit({ commit, rootState, dispatch }) {
    const apiUrl = rootState.app.menu.parameters
    if (apiUrl) {
      commit(PARAMETERS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        // const access = {
        //   privileges: ['motorRatingReview', 'travelRatingReview']
        // }
        // if (checkAccess(access)) {
        //   await dispatch('tariffListInit', commitResult)
        //   await dispatch('factorListInit', commitResult)
        // }
        commit(PARAMETERS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PARAMETERS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PARAMETERS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  },
  async moduleInit({ commit, state }) {
    const apiUrl = state.menu.module
    if (apiUrl) {
      commit(MODGENERAL_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(MODGENERAL_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(MODGENERAL_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PARAMETERS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  }
}
